import { render, staticRenderFns } from "./addNews.vue?vue&type=template&id=a381b506&scoped=true&"
import script from "./addNews.vue?vue&type=script&lang=js&"
export * from "./addNews.vue?vue&type=script&lang=js&"
import style0 from "./addNews.vue?vue&type=style&index=0&id=a381b506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a381b506",
  null
  
)

export default component.exports